// El backend mezcla dos formatos de timestamp: naive-UTC de SQLite
// ('YYYY-MM-DD HH:MM:SS', vía datetime('now') — sin marca de timezone) e ISO
// real con 'Z' (vía new Date().toISOString() en el código de la app). El
// primer formato, sin marca de zona, el browser lo parsea como hora LOCAL —
// corriendo la fecha por el offset del usuario. Bug real reproducido: EDT
// (UTC-4) mostró "in 12,051 seconds" en vez de "hace 3 horas".
// parseServerDate normaliza ambos casos a UTC explícito antes de construir el
// Date — es un no-op seguro para strings que ya tienen 'Z' o un offset.
export function parseServerDate(iso: string): Date {
  const hasTz = /[zZ]$|[+-]\d{2}:\d{2}$/.test(iso);
  return new Date(hasTz ? iso : `${iso.replace(' ', 'T')}Z`);
}
